// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-gradient {
  display: inline-block;
  position: relative;
  overflow: hidden;
  width: 100%;
  font-family: "Roboto", sans-serif;
  transition: all 0.3s ease;
  padding: 1px;
  border-radius: 8.485px;
}
.input-gradient:hover input {
  border-color: #f4f4f4;
}
.input-gradient:hover:after {
  width: 100%;
}
.input-gradient label {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.input-gradient input {
  position: relative;
  display: inline-block;
  width: 100%;
  padding: 26px 22px 14px 22px;
  outline: none;
  border-radius: 8.485px;
  background: var(--primary-color);
  border: 1px solid #2B2B2B;
  z-index: 1;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 149.68%;
  color: #F4F4F4;
  transition: all 0.3s ease;
  letter-spacing: normal;
}
.input-gradient input:focus ~ span, .input-gradient input:not(:placeholder-shown) ~ span {
  font-size: 12px;
  line-height: 18px;
  color: #F4F4F4;
  transform: translateY(-13px);
}
.input-gradient__label {
  position: absolute;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  left: 23px;
  font-weight: 400;
  letter-spacing: 1.95px;
  font-size: 15px;
  line-height: 100%;
  color: #BBB7B7;
  transition: all 0.3s ease;
  z-index: 1;
  -webkit-user-select: none;
          user-select: none;
  cursor: text;
}
.input-gradient__message {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--primary-color);
  border-radius: 8.485px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  padding-left: 49px;
}
.input-gradient__message.active {
  opacity: 1;
  visibility: visible;
  z-index: 1;
}
.input-gradient__message-text {
  color: #BBB7B7;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.input-gradient.error input {
  border-color: #ff0000;
}
.input-gradient.error input:hover {
  border-color: #ff0000;
}
.input-gradient.error span {
  color: #ff0000 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/Input/Input.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;AADF;AAGI;EACE,qBAAA;AADN;AASI;EACE,WAAA;AAPN;AAUE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AARJ;AAUE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,4BAAA;EAEA,aAAA;EACA,sBAAA;EACA,gCCvCG;EDwCH,yBAAA;EACA,UAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AATJ;AAWM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;AATR;AAaE;EACE,kBAAA;EAEA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;AAZJ;AAcE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,gCClFG;EDmFH,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAZJ;AAaI;EACE,UAAA;EACA,mBAAA;EACA,UAAA;AAXN;AAaI;EACE,cAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAXN;AAeI;EACE,qBAAA;AAbN;AAeM;EACE,qBAAA;AAbR;AAgBI;EACE,yBAAA;AAdN","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.input-gradient{\r\n  display: inline-block;\r\n  position: relative;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  font-family: \"Roboto\",sans-serif;\r\n  transition: all 0.3s ease;\r\n  padding: 1px;\r\n  border-radius: 8.485px;\r\n  &:hover{\r\n    input {\r\n      border-color: #f4f4f4;\r\n    }\r\n    &:not(:focus-within){\r\n\r\n\r\n     // background: rgba(81, 86, 91, 0.45);\r\n    }\r\n\r\n    &:after{\r\n      width: 100%;\r\n    }\r\n  }\r\n  label{\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  input{\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 100%;\r\n    padding: 26px 22px 14px 22px;\r\n\r\n    outline: none;\r\n    border-radius: 8.485px;\r\n    background: $main;\r\n    border: 1px solid #2B2B2B;\r\n    z-index: 1;\r\n    font-family: \"Roboto\",sans-serif;\r\n    font-weight: 400;\r\n    font-size: 13px;\r\n    line-height: 149.68%;\r\n    color: #F4F4F4;\r\n    transition: all 0.3s ease;\r\n    letter-spacing: normal;\r\n    &:focus,&:not(:placeholder-shown){\r\n      ~ span{\r\n        font-size: 12px;\r\n        line-height: 18px;\r\n        color: #F4F4F4;\r\n        transform: translateY(-13px);\r\n      }\r\n    }\r\n  }\r\n  &__label{\r\n    position: absolute;\r\n    //display: inline;\r\n    top: 0px;\r\n    bottom: 0px;\r\n    display: flex;\r\n    align-items: center;\r\n    left: 23px;\r\n    font-weight: 400;\r\n    letter-spacing: 1.95px;\r\n    font-size: 15px;\r\n    line-height: 100%;\r\n    color: #BBB7B7;\r\n    transition: all 0.3s ease;\r\n    z-index: 1;\r\n    user-select:none;\r\n    cursor: text;\r\n  }\r\n  &__message{\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: $main;\r\n    border-radius: 8.485px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 0;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: all 0.3s ease;\r\n    padding-left: 49px;\r\n    &.active{\r\n      opacity: 1;\r\n      visibility: visible;\r\n      z-index:1;\r\n    }\r\n    &-text{\r\n      color: #BBB7B7;\r\n      font-family: \"Roboto\",sans-serif;\r\n      font-size: 15px;\r\n      font-style: normal;\r\n      font-weight: 700;\r\n      line-height: normal;\r\n    }\r\n  }\r\n  &.error{\r\n    input{\r\n      border-color:#ff0000;\r\n\r\n      &:hover{\r\n        border-color:#ff0000\r\n      }\r\n    }\r\n    span{\r\n      color:#ff0000 !important;\r\n    }\r\n  }\r\n}\r\n","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
